import React, { useState, useRef } from 'react';
import './FavoritesSection.css';

const FavoritesSection = ({ isLoggedOut = false }) => {
  // Liked Events Data
  const likedEvents = [
    {
      id: 1,
      artist: 'Fiona',
      title: 'We Are The Universe',
      date: '9.22 Mon @7pm',
      location: 'BBCB, Itaewon',
      likes: 57,
      rating: '10/10',
      image: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=300&h=200&fit=crop'
    },
    {
      id: 2,
      artist: 'Fiona',
      title: 'We Are The Universe',
      date: '9.22 Mon @7pm',
      location: 'BBCB, Itaewon',
      likes: 57,
      rating: '10/10',
      image: 'https://images.unsplash.com/photo-1516280440614-37939bbacd81?w=300&h=200&fit=crop'
    },
    {
      id: 3,
      artist: 'Fiona',
      title: 'We Are The Universe',
      date: '9.22 Mon @7pm',
      location: 'BBCB, Itaewon',
      likes: 57,
      rating: '10/10',
      image: 'https://images.unsplash.com/photo-1598653222000-6b7b7a552625?w=300&h=200&fit=crop'
    },
    {
      id: 4,
      artist: 'Fiona',
      title: 'We Are The Universe',
      date: '9.22 Mon @7pm',
      location: 'BBCB, Itaewon',
      likes: 57,
      rating: '10/10',
      image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=300&h=200&fit=crop'
    },
    {
      id: 5,
      artist: 'Fiona',
      title: 'We Are The Universe',
      date: '9.22 Mon @7pm',
      location: 'BBCB, Itaewon',
      likes: 57,
      rating: '10/10',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300&h=200&fit=crop'
    },
    {
      id: 6,
      artist: 'Fiona',
      title: 'We Are The Universe',
      date: '9.22 Mon @7pm',
      location: 'BBCB, Itaewon',
      likes: 57,
      rating: '10/10',
      image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=300&h=200&fit=crop'
    }
  ];

  // Following Artists Data
  const followingArtists = [
    {
      id: 1,
      name: 'Fiona',
      image: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=150&h=150&fit=crop&crop=face',
      status: 'FOLLOWING'
    },
    {
      id: 2,
      name: 'Fiona',
      image: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=150&h=150&fit=crop&crop=face',
      status: 'FOLLOWING'
    },
    {
      id: 3,
      name: 'Fiona',
      image: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=150&h=150&fit=crop&crop=face',
      status: 'FOLLOWING'
    },
    {
      id: 4,
      name: 'Fiona',
      image: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=150&h=150&fit=crop&crop=face',
      status: 'FOLLOWING'
    },
    {
      id: 5,
      name: 'Fiona',
      image: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=150&h=150&fit=crop&crop=face',
      status: 'FOLLOWING'
    },
    {
      id: 6,
      name: 'Fiona',
      image: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=150&h=150&fit=crop&crop=face',
      status: 'FOLLOWING'
    }
  ];

  // My Chatroom Data
  const myChatrooms = [
    {
      id: 1,
      name: 'Fiona Lovers',
      description: "Let's share all your love for Fiona",
      hashtags: '#fiona #redhat #concertgoers #comingtomytown',
      participants: 576,
      image: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=100&h=100&fit=crop',
      label: 'MMUNITY'
    },
    {
      id: 2,
      name: 'Fiona Lovers',
      description: "Let's share all your love for Fiona",
      hashtags: '#fiona #redhat #concertgoers #comingtomytown',
      participants: 576,
      image: 'https://images.unsplash.com/photo-1516280440614-37939bbacd81?w=100&h=100&fit=crop',
      label: 'MMUNITY'
    },
    {
      id: 3,
      name: 'Fiona Lovers',
      description: "Let's share all your love for Fiona",
      hashtags: '#fiona #redhat #concertgoers #comingtomytown',
      participants: 576,
      image: 'https://images.unsplash.com/photo-1598653222000-6b7b7a552625?w=100&h=100&fit=crop',
      label: 'MMUNITY'
    },
    {
      id: 4,
      name: 'Fiona Lovers',
      description: "Let's share all your love for Fiona",
      hashtags: '#fiona #redhat #concertgoers #comingtomytown',
      participants: 576,
      image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=100&h=100&fit=crop',
      label: 'MMUNITY'
    },
    {
      id: 5,
      name: 'Fiona Lovers',
      description: "Let's share all your love for Fiona",
      hashtags: '#fiona #redhat #concertgoers #comingtomytown',
      participants: 576,
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop',
      label: 'MMUNITY'
    },
    {
      id: 6,
      name: 'Fiona Lovers',
      description: "Let's share all your love for Fiona",
      hashtags: '#fiona #redhat #concertgoers #comingtomytown',
      participants: 576,
      image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop',
      label: 'MMUNITY'
    }
  ];

  const [currentEventIndex, setCurrentEventIndex] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const carouselRef = useRef(null);
  const itemsPerView = 3;

  const nextEventSlide = () => {
    setCurrentEventIndex((prevIndex) => 
      prevIndex + itemsPerView >= likedEvents.length ? 0 : prevIndex + 1
    );
  };

  const prevEventSlide = () => {
    setCurrentEventIndex((prevIndex) => 
      prevIndex === 0 ? Math.max(0, likedEvents.length - itemsPerView) : prevIndex - 1
    );
  };

  // Drag functionality for events carousel
  const handleEventMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - carouselRef.current.offsetLeft);
    setScrollLeft(currentEventIndex);
  };

  const handleEventMouseLeave = () => {
    setIsDragging(false);
  };

  const handleEventMouseUp = () => {
    setIsDragging(false);
  };

  const handleEventMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - carouselRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    const newIndex = Math.max(0, Math.min(likedEvents.length - itemsPerView, scrollLeft - walk / 100));
    setCurrentEventIndex(Math.round(newIndex));
  };

  // Touch events for mobile
  const handleEventTouchStart = (e) => {
    setIsDragging(true);
    setStartX(e.touches[0].pageX - carouselRef.current.offsetLeft);
    setScrollLeft(currentEventIndex);
  };

  const handleEventTouchMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.touches[0].pageX - carouselRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    const newIndex = Math.max(0, Math.min(likedEvents.length - itemsPerView, scrollLeft - walk / 100));
    setCurrentEventIndex(Math.round(newIndex));
  };

  const handleEventTouchEnd = () => {
    setIsDragging(false);
  };

  return (
    <section className="my-favorites" id="favorites">
      <div className="container">
        <div className="section-header">
          <h2>{isLoggedOut ? 'Trending Now' : 'My Favorites'}</h2>
        </div>
        
        <div className="favorites-grid">
          {/* Liked Events Section */}
          <div className="favorites-section">
            <h3 className="section-title">{isLoggedOut ? 'Trending Events' : 'Liked Events'}</h3>
            <div className="carousel-container">
              <button className="carousel-btn prev-btn" onClick={prevEventSlide}>
                <i className="fas fa-chevron-left"></i>
              </button>
              
              <div 
                className="events-carousel"
                ref={carouselRef}
                onMouseDown={handleEventMouseDown}
                onMouseLeave={handleEventMouseLeave}
                onMouseUp={handleEventMouseUp}
                onMouseMove={handleEventMouseMove}
                onTouchStart={handleEventTouchStart}
                onTouchMove={handleEventTouchMove}
                onTouchEnd={handleEventTouchEnd}
                style={{ cursor: isDragging ? 'grabbing' : 'grab' }}
              >
                <div className="carousel-track" style={{ transform: `translateX(-${currentEventIndex * (100 / itemsPerView)}%)` }}>
                  {likedEvents.map((event) => (
                    <div key={event.id} className="event-card">
                      <div className="event-image">
                        <img src={event.image} alt={event.title} />
                        <div className="event-icons">
                          <div className="event-icon purple-icon"></div>
                          <div className="event-icon heart-icon">
                            <i className="far fa-heart"></i>
                          </div>
                        </div>
                      </div>
                      <div className="event-info">
                        <h4 className="artist-name">{event.artist}</h4>
                        <h5 className="event-title">{event.title}</h5>
                        <div className="event-details">
                          <div className="event-detail">
                            <i className="fas fa-clock"></i>
                            <span>{event.date}</span>
                          </div>
                          <div className="event-detail">
                            <i className="fas fa-map-marker-alt"></i>
                            <span>{event.location}</span>
                          </div>
                          <div className="event-detail">
                            <i className="fas fa-heart"></i>
                            <span>{event.likes}</span>
                          </div>
                          <div className="event-detail">
                            <i className="fas fa-star"></i>
                            <span>{event.rating}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              
              <button className="carousel-btn next-btn" onClick={nextEventSlide}>
                <i className="fas fa-chevron-right"></i>
              </button>
            </div>
            
            <div className="carousel-indicators">
              {Array.from({ length: Math.ceil(likedEvents.length / itemsPerView) }).map((_, index) => (
                <button
                  key={index}
                  className={`indicator ${Math.floor(currentEventIndex / itemsPerView) === index ? 'active' : ''}`}
                  onClick={() => setCurrentEventIndex(index * itemsPerView)}
                />
              ))}
            </div>
          </div>

          {/* Following Artists Section */}
          <div className="favorites-section">
            <h3 className="section-title">{isLoggedOut ? 'Popular Artists' : 'Following Artists'}</h3>
            <div className="artists-grid">
              {followingArtists.map((artist) => (
                <div key={artist.id} className="artist-card">
                  <div className="artist-image">
                    <img src={artist.image} alt={artist.name} />
                  </div>
                  <h4 className="artist-name">{artist.name}</h4>
                  <div className="following-status">{artist.status}</div>
                </div>
              ))}
            </div>
          </div>

          {/* My Chatroom Section */}
          <div className="favorites-section">
            <h3 className="section-title">{isLoggedOut ? 'Community Rooms' : 'My Chatroom'}</h3>
            <div className="chatrooms-grid">
              {myChatrooms.map((chatroom) => (
                <div key={chatroom.id} className="chatroom-card">
                  <div className="chatroom-image">
                    <img src={chatroom.image} alt={chatroom.name} />
                    <div className="chatroom-label">{chatroom.label}</div>
                  </div>
                  <div className="chatroom-info">
                    <h4 className="chatroom-name">{chatroom.name}</h4>
                    <p className="chatroom-description">{chatroom.description}</p>
                    <p className="chatroom-hashtags">{chatroom.hashtags}</p>
                    <div className="chatroom-footer">
                      <div className="participants">
                        <i className="fas fa-user"></i>
                        <span>{chatroom.participants}</span>
                      </div>
                      <button className="join-btn">JOIN</button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FavoritesSection;
